module.exports = __webpack_public_path__ + "img/machines_grey.ee39b116.svg";